import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  Flex,
  Text,
  List,
  useMantineTheme,
  Avatar,
  Input,
} from "@mantine/core";
import { BiSearch } from "react-icons/bi";
import useAppMain from "src/hooks/useAppMain";
import { CLIENT_TAB_LIST } from "src/utils/constants";

const ClientsList = () => {
  useAppMain(CLIENT_TAB_LIST.GROUPS, true);
  const theme = useMantineTheme();
  const location = useLocation();
  const {
    state: { groupName, clients },
  } = location;

  const [searchedList, setSearchedList] = useState(clients || []);
  const [searchedValue, setSearchedValue] = useState<string>("");

  const onSearchList = () => {
    const searchedClients = clients.filter((client: any) => {
      const { user } = client;
      const username = `${user.firstName.toLowerCase()} ${user.lastName.toLowerCase()}`;
      return username.includes(searchedValue.toLowerCase());
    });
    setSearchedList(searchedClients);
  };

  useEffect(() => {
    onSearchList();
  }, [searchedValue]);

  return (
    <Flex direction={"column"}>
      <Text size={18} fw={500} color={theme.colors.secondaryTextColor[6]}>
        {groupName}
      </Text>
      <Input
        mt={20}
        icon={<BiSearch />}
        placeholder="Search members"
        value={searchedValue}
        onChange={(e) => setSearchedValue(e.target.value)}
      />
      <List
        my={10}
        styles={{
          itemWrapper: {
            width: "100%",
          },
          item: {
            listStyle: "none",
            cursor: "pointer",
            borderBottom: `1px solid #DDDDDD`,
            color: theme.colors.secondaryTextColor[6],
          },
        }}
      >
        {searchedList &&
          searchedList.map((client: any) => {
            const { user } = client;
            return (
              <List.Item key={client.id} my={15} py={10}>
                <Flex align={"center"}>
                  <Avatar
                    styles={{
                      placeholder: {
                        backgroundColor: theme.colors.primary[6],
                        color: theme.colors.primaryTextColor[6],
                      },
                    }}
                    radius="xl"
                    mr={20}
                  >
                    {`${
                      user?.firstName?.charAt(0) + user?.lastName?.charAt(0)
                    }`}
                  </Avatar>
                  <Text fw={400} size={16}>
                    {`${user?.firstName} ${user?.lastName}`}
                  </Text>
                </Flex>
              </List.Item>
            );
          })}
      </List>
    </Flex>
  );
};

export default ClientsList;
